import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_134_account_heads: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "135",
      action: "navigate_modulev1/heads_add",
    },
    title: "Account heads",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "ledger_name",
            Name: "account_heads_summary",
            BindValue: "grid_vehicle",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/heads_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "135",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "account_heads_summary",
                },
                ActionType: "Delete",
                ScreenId: "134",
              },
            ],
            Form: {
              Name: "account_heads_summary",
              TableName: "ledgers",
              DisplayName: "ItemGroup details",
              View: "View_account_heads",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Sub name",
                  IsMandatory: true,
                  BindValue: "txt_heads",
                  Json_Attribute: "ledger_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Head name",
                  IsMandatory: true,
                  BindValue: "txt_group_name",
                  Json_Attribute: "group_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "main_head_id",
                  BindValue: "main_head_id",
                  Json_Attribute: "main_head_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "main_head_group_id",
                  BindValue: "main_head_group_id",
                  Json_Attribute: "main_head_group_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "group_id",
                  BindValue: "group_id",
                  Json_Attribute: "group_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

